var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNebraska(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.976,202.434l-9.29-13.732c0,0-1.43-2.866-2.896-6.797c-0.87-2.332-1.752-5.039-2.354-7.748 c-0.27-1.205-0.896-3.709-1.75-7.039c-0.852-3.31-1.928-7.435-3.109-11.933c-4.793-18.21-11.299-42.425-11.299-42.425h-4.039 l-3.637-6.462l-13.358-6.68l-1.185-0.591l-19.387,2.423l-12.924-8.885L31.831,85.705l-6.019,69.48l-0.137,1.604l54.53,4.038 l-2.345,36.515L261.976,202.434z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNebraska);
export default __webpack_public_path__ + "static/media/nebraska.e07ad625c87f283b7a290d3278de4a79.svg";
export { ForwardRef as ReactComponent };